import {UserStore} from "data/stores/user/user.store";
import {ENVIRONMENT} from "data/constants";

const trkGuid = "cd1a17fb-a9df-4aba-8c16-9c2763d680d8";
export enum EventGUID {
	HomepageClick = "3003904c-0fe0-40dc-b492-eb7a7faef7de",
	ResultsPageClick = "274ddfd2-66c2-4551-a1b2-41a95cbac1db",
	LeaderboardPageClick = "322e8afe-f2fa-481d-94f3-a2016ea53503",
	HelpPageClick = "8b7938ca-a3d9-422c-9328-cb3251f5a272",
	LeaderboardCTAClick = "d00215c1-d218-456d-b94d-e7e4eb5e279e",
	HomepageScheduleNavigationClick = "a63a2663-0e1c-411e-a75c-a161ddde58fc",
	ContestClick = "a554becd-4be8-449d-a29c-4b579bbf0a76",
	PickSubmit = "e266e081-a931-43c3-8427-b7f2b5a3e1c0",
	PickUpdated = "52760a23-10b2-4a11-a951-db87abb2e7af",
	ContestPageLoad = "d668938d-1cc2-476a-8df3-dc404d73ac2d",
	PostpickModalToAdditionalClick = "18401de6-05eb-474c-9a7b-c113583c4f70",
	PostpickModalToLeaderboard = "c2a2be1f-7396-48ef-9938-e3727dd2c264",
	FAQClick = "4019afa3-4df8-43c4-b297-fe37de7ea7b1",
	LanguageChangeClick = "f9b38f4f-8432-4fb5-96ab-9154f9649c3b",
	ResultsScheduleNavigationClick = "f850170a-684b-41cb-9b55-45e68f6dd62a",
	ResultsTileClick = "58936996-623c-4181-b677-aab5561d7b37",
	PlayerHeadshotClick = "1404650b-1e1b-4b90-a002-c56000eaf326",
	FinalResultsPageToLeaderboard = "6ff09e22-1b7d-4963-8a09-c469f1a50f20",
	OverallLeaderboardClick = "8e179713-233b-40b0-85dd-815637fdb323",
	MyVotesClickFromLeaderboard = "3ab0cbaa-5850-4c3e-93ed-3267ff2718ea",
	UnauthenticatedLoginClickFromLeaderboard = "b1a94187-9523-4d6d-bb0f-72d616656b67",
	CompletedContestClick = "effb56f1-50f4-4d06-aea8-c6476fa15eda",
	POTG_SpinballClick = "9f22aff8-0b49-42c7-b231-100bece14d89",
	POTG_BTSClick = "97182dd1-ce2e-4100-9f68-3317ceb54c72",
	POTG_BTNClick = "17d57002-dc29-42f9-ae34-df1adf8b344c",
}

export const createFanHubEvent = (evtGuid: EventGUID) => {
	try {
		const clientUserId = UserStore.UUID ? String(UserStore.UUID) : null;
		const url = null;
		const d1 = null;
		const d2 = null;
		const d3 = null;
		const cnvValue = null;
		const cnvCurrency = null;
		const orderId = null;

		if (ENVIRONMENT === "uat") {
			console.log("fanhubEvent", {
				evtGuid,
				clientUserId,
			});
		}

		window.FanHub?.createEvent(
			evtGuid,
			trkGuid,
			url,
			d1,
			d2,
			d3,
			cnvValue,
			clientUserId,
			cnvCurrency,
			orderId
		);
	} catch (e) {
		console.error(e);
	}
};

export const createFanHubEventScriptTag = (evtGuid: EventGUID) => {
	const elementName = "script";
	const SCRIPT_ID = "fanhub-tagging";
	document.getElementById(SCRIPT_ID)?.remove();

	const src = `https://tag.fanhub.geniussports.com/js/evt.js`;
	const url = new URL(src);
	const script = document.createElement(elementName);
	const clientUserId = UserStore.UUID ? String(UserStore.UUID) : null;

	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	console.log(evtGuid);
	script.setAttribute("data-trkGuid", trkGuid);
	script.setAttribute("data-evtGuid", evtGuid);

	if (clientUserId) {
		script.setAttribute("data-clientUserId", clientUserId);
	}

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	return script;
};
